// extracted by mini-css-extract-plugin
module.exports = {"content":"artist_content_2O6B-","view":"artist_view_3GpFm","wrapper":"artist_wrapper_2VtzZ","slider":"artist_slider_1-nZX","bio-visible":"artist_bio-visible_3o1UV"};